var i = Object.defineProperty, p = Object.defineProperties;
var c = Object.getOwnPropertyDescriptors;
var e = Object.getOwnPropertySymbols;
var l = Object.prototype.hasOwnProperty, s = Object.prototype.propertyIsEnumerable;
var o = (t, r, a) => r in t ? i(t, r, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[r] = a, m = (t, r) => {
  for (var a in r || (r = {}))
    l.call(r, a) && o(t, a, r[a]);
  if (e)
    for (var a of e(r))
      s.call(r, a) && o(t, a, r[a]);
  return t;
}, f = (t, r) => p(t, c(r));
import n, { forwardRef as d } from "react";
import w from "../lib/IconBase.mjs";
import H from "../defs/StarHalf.mjs";
const R = d((t, r) => /* @__PURE__ */ n.createElement(w, f(m({ ref: r }, t), { weights: H })));
R.displayName = "StarHalf";
export {
  R as StarHalf
};
